import { ReactComponent as AvatarIcon } from "./research-assistant-avatar.svg";

const ResearchAssistantAvatar = ({ className }: { className?: string }) => {
  return <AvatarIcon className={className} />;
};

export default ResearchAssistantAvatar;
